"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSoundproofing = function SvgSoundproofing(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.5v-7H5A1.5 1.5 0 0 0 3.5 10v4A1.5 1.5 0 0 0 5 15.5h1.5zm0-.142V8.713l6.219-4.235a.5.5 0 0 1 .781.413v14.232a.5.5 0 0 1-.779.415L6.5 15.358z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.485 4.084V20.02M19 4.084l-.824 1.966a1 1 0 0 0 .024.826l.584 1.194a1 1 0 0 1 0 .88l-.563 1.148a1 1 0 0 0 .006.896l.548 1.073a1 1 0 0 1 .01.887l-.567 1.18a1 1 0 0 0 .016.899l.533 1.013a1 1 0 0 1 .017.897l-.533 1.115a1 1 0 0 0 .081 1.002l.668.96M16.485 4.084l-.564.78a.916.916 0 0 0 .064 1.153l.019.021a.758.758 0 0 1-.02 1.04l-.008.01a.706.706 0 0 0 .009.995l.002.002a.689.689 0 0 1-.002.982l-.005.004a.674.674 0 0 0 .005.968.676.676 0 0 1 .005.968l-.005.005a.703.703 0 0 0-.01.993l.03.03a.672.672 0 0 1-.02.96.665.665 0 0 0-.014.954l.017.018a.695.695 0 0 1-.003.988.704.704 0 0 0-.01.994l.013.013a.724.724 0 0 1-.003 1.015l-.006.006a.703.703 0 0 0 .006.994.964.964 0 0 1 .182 1.122l-.468.92",
    stroke: "#4D4D4D"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgSoundproofing);
var _default = Memo;
exports["default"] = _default;